<div class="op-dialog">

  <div class="op-header">
    <h2 class="op-title">
      <mat-icon>trending_up</mat-icon>
      Operación de Entrada
    </h2>
    <div class="op-header-actions">
      <mat-button-toggle-group *ngIf="isBroker" class="op-seg" name="livesincro" aria-label="Modo de la operación"
          [(ngModel)]="sincro" (change)="onCambioSincro()" hideSingleSelectionIndicator>
        <mat-button-toggle [value]="false" class="seg-live" matTooltip="Envía la orden al broker">
          <span class="live-dot"></span>Live
        </mat-button-toggle>
        <mat-button-toggle [value]="true" class="seg-sincro" matTooltip="Solo registra la operación (sin orden al broker)">
          <mat-icon>sync</mat-icon>Sincro
        </mat-button-toggle>
      </mat-button-toggle-group>
      <button mat-icon-button class="close-button" mat-dialog-close aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="op-content">
    <div class="op-columns" [class.con-whatif]="showWhatIf">

      <!-- Formulario -->
      <div class="op-form">

        <app-cotizacion-fuente
            [wallet]="optimawalletOpe" [isBroker]="isBroker" [stkcfd]="stkcfd" [tipoEditable]="isBroker"
            (stkcfdChange)="stkcfd = $event; onCambioStkcfd()"
            [idNectum]="companiaOpe.idNectum" [symbol]="companiaOpe.iso" [conid]="companiaOpe.conid"
            [fecha]="companiaOpe.fecha" [decimales]="decimales" [descripcion]="companiaOpe.descripcion"
            (precio)="onPrecio($event)" (sinDatos)="isHabil = $event"
            (contrato)="companiaOpe.currency = $event.currency; companiaOpe.listingExchange = $event.listingExchange">
          <div *ngIf="marketCountdownText" class="market-countdown"
               [ngClass]="{'market-open': isMarketOpen, 'market-closed': !isMarketOpen}">
            <span class="market-name" *ngIf="marketDisplayName">{{ marketDisplayName }}</span>
            <span class="status">{{ isMarketOpen ? 'Abierto' : 'Cerrado' }}</span>
            <span class="separator">•</span>
            <span class="countdown">{{ marketCountdownText }}</span>
            <span class="timezone" *ngIf="marketTimezone">({{ marketTimezone }})</span>
          </div>
        </app-cotizacion-fuente>

        <!-- Compañía -->
        <div class="section-header section-header--inline mt-3">
          <mat-icon class="small-icon">business</mat-icon>
          <span>Compañía</span>
          <input type="text" class="dense-input compania-input" placeholder="ex. AAPL" aria-label="Compañía"
              [formControl]="myControl" [matAutocomplete]="auto" (focus)="$any($event.target).select()">
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selected($event)">
            <cdk-virtual-scroll-viewport itemSize="10" style="height: 223px; width: 100%;">
              <mat-option *cdkVirtualFor="let option of filteredOptions | async" [value]="option.iso">
                <strong>{{ option.iso }}</strong>
              </mat-option>
            </cdk-virtual-scroll-viewport>
          </mat-autocomplete>
          <mat-button-toggle-group class="op-seg op-seg--sm ms-auto" name="direccion" aria-label="Dirección"
              [ngModel]="optimawalletOpe.bajista ? 'bajista' : 'alcista'"
              (ngModelChange)="optimawalletOpe.bajista = $event === 'bajista'; activarPrecioOrden()"
              hideSingleSelectionIndicator>
            <mat-button-toggle value="alcista" class="seg-alcista">Alcista</mat-button-toggle>
            <mat-button-toggle value="bajista" class="seg-bajista">Bajista</mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <!-- Orden (solo si no sincro) -->
        <ng-container *ngIf="!sincro">
          <div class="section-header mt-3">
            <mat-icon class="small-icon">receipt_long</mat-icon>
            <span>Orden</span>
          </div>

          <div class="fields-grid">
            <label class="field-label">Tipo Orden</label>
            <select class="dense-input"
                [(ngModel)]="ordersData.orders[0].orderType"
                name="orderType" aria-label="Tipo de orden"
                (ngModelChange)="activarPrecioOrden()">
              <option value="{{type}}" *ngFor="let type of orderType">{{type}}</option>
            </select>

            <ng-container *ngIf="activateedPrecioOrden">
              <label class="field-label">Precio Orden</label>
              <input type="number" class="dense-input" [(ngModel)]="ordersData.orders[0].price" step="0.01">

              <label class="field-label">Porcentaje</label>
              <input type="number" class="dense-input" [(ngModel)]="porcentaje"
                  (ngModelChange)="activarPrecioOrden()" step="0.01">
            </ng-container>
          </div>
        </ng-container>

        <!-- Parámetros -->
        <div class="section-header mt-3">
          <mat-icon class="small-icon">analytics</mat-icon>
          <span>Parámetros</span>
        </div>

        <div class="fields-grid">
          <label class="field-label">Cotizacion</label>
          <input type="number" class="dense-input" [(ngModel)]="companiaOpe.precioteorico"
              (ngModelChange)="recalcular($event, 'precio')" step="0.01">

          <label class="field-label">Nivel Stoploss</label>
          <input type="number" class="dense-input" [ngModel]="stoploss" step="0.01">

          <label class="field-label">Nº Acciones</label>
          <input type="number" class="dense-input" [(ngModel)]="companiaOpe.numcciones"
              (ngModelChange)="recalcular($event, 'nacciones')">

          <label class="field-label">Coste</label>
          <input type="number" class="dense-input" [(ngModel)]="coste" step="0.01" [disabled]="true">

          <label class="field-label">Riesgo Ope.</label>
          <input type="number" class="dense-input" [(ngModel)]="riesgooperacion" step="0.01" [disabled]="true">

          <label class="field-label">Stop Loss %</label>
          <input type="number" class="dense-input" [(ngModel)]="companiaOpe.stoplosspor"
              [disabled]="true" min="0.001" max="100">
        </div>

        <!-- Fecha (en Broker Live siempre hoy) -->
        <div class="section-header mt-3">
          <mat-icon class="small-icon">calendar_today</mat-icon>
          <span>Fecha</span>
        </div>

        <div class="fields-grid">
          <label class="field-label">Fecha</label>
          <input type="date" class="dense-input" [(ngModel)]="companiaOpe.fecha"
              [disabled]="isBroker && !sincro">
        </div>

        <div *ngIf="isHabil" class="alert-no-numbers">
          Fecha sin data de cotización en ninguna fuente.
        </div>

        <div *ngIf="avisoMercadoCerrado" class="alert-no-numbers">
          Mercado cerrado: la orden puede ser rechazada o ejecutarse en la próxima apertura.
        </div>

      </div>

      <!-- What-If (solo IBKR; MetaAPI no tiene what-if, no reservar espacio) -->
      <div class="op-whatif" *ngIf="showWhatIf">
        <div *ngIf="whatIfLoading" class="text-center py-2">
          <span class="spinner-border spinner-border-sm"></span> Calculando What‑If…
        </div>

        <div *ngIf="whatIfError" class="alert alert-warning small mb-2">
          {{ whatIfError }}
        </div>

        <div *ngIf="!whatIfLoading && !whatIfError && whatIfData" class="small">
          <div class="section-header">
            <mat-icon class="small-icon">calculate</mat-icon>
            <span>What‑If (IBKR)</span>
          </div>

          <div class="whatif-table-wrapper">
            <table class="whatif-table">
              <tbody>
                <tr>
                  <th>Monto</th><td>{{ whatIfData?.amount?.amount || '—' }}</td>
                  <th>Comisión</th><td>{{ whatIfData?.amount?.commission || '—' }}</td>
                  <th>Total</th><td>{{ whatIfData?.amount?.total || '—' }}</td>
                </tr>
                <tr>
                  <th>Equity</th><td>{{ whatIfData?.equity?.current || '—' }}</td>
                  <th>Cambio</th><td>{{ whatIfData?.equity?.change || '—' }}</td>
                  <th>Después</th><td>{{ whatIfData?.equity?.after || '—' }}</td>
                </tr>
                <tr>
                  <th>Inicial</th><td>{{ whatIfData?.initial?.current || '—' }}</td>
                  <th>Cambio</th><td>{{ whatIfData?.initial?.change || '—' }}</td>
                  <th>Después</th><td>{{ whatIfData?.initial?.after || '—' }}</td>
                </tr>
                <tr>
                  <th>Mantenimiento</th><td>{{ whatIfData?.maintenance?.current || '—' }}</td>
                  <th>Cambio</th><td>{{ whatIfData?.maintenance?.change || '—' }}</td>
                  <th>Después</th><td>{{ whatIfData?.maintenance?.after || '—' }}</td>
                </tr>
                <tr>
                  <th>Posición</th><td>{{ whatIfData?.position?.current || '—' }}</td>
                  <th>Cambio</th><td>{{ whatIfData?.position?.change || '—' }}</td>
                  <th>Después</th><td>{{ whatIfData?.position?.after || '—' }}</td>
                </tr>
                <tr *ngIf="whatIfData?.accruedInterest">
                  <th>Interés devengado</th>
                  <td colspan="5">{{ whatIfData?.accruedInterest }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="whatIfData?.warns?.length" class="alert alert-info small mt-2">
            <ul class="mb-0" style="white-space: pre-wrap;">
              <li *ngFor="let w of whatIfData.warns">{{ w }}</li>
            </ul>
          </div>
          <div *ngIf="!whatIfData?.warns?.length && whatIfData?.warn"
               class="alert alert-info small mt-2" style="white-space: pre-wrap;">
            {{ whatIfData.warn }}
          </div>
          <div *ngIf="whatIfData?.error" class="alert alert-danger small mt-2">
            {{ whatIfData.error }}
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="op-actions">
    <button mat-stroked-button mat-dialog-close>Cancelar</button>
    <button mat-flat-button color="primary" [disabled]="isHabil || enviando" (click)="registrar()">
      {{ enviando ? 'Enviando…' : 'Aceptar' }}
    </button>
  </div>

</div>
